import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import TransferModel from './transferModel.vue'
import ConcatModal from '@/components/TabsContacts/fbu/editModal.vue'
import CustomerAssign from '@/views/gucangSales/customerCenter/components/customerAssign.vue'

const __default__ = { name: 'viewFooterBtn' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  workCode: {
    type: String
  },
  type: {
    type: String
  },
  loading: {
    type: Boolean
  },
  data: {
    type: Object
  },
  isPublicClue: {
    type: Boolean
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const transferModelRef = ref()
const concatModalRef = ref()
const router = useRouter()
const route = useRoute()
const emit = __emit
const props = __props
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle([{ cosId: route.query.cosId }])
}
// 新增联系人
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
// 新增访客计划
const hanleVisitor = () => {
  router.push({
    path: '/fbu/visitorProgram/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}

// 分配客户负责人
const customerAssignRef = ref()
const handleAssignPerson = () => {
  customerAssignRef.value?.init([props.data])
}

// 转移客户和新增联系人成功回调
const successPage = (tag: any) => {
  emit('success', tag)
}
// 新增跟进记录
const handleAddFollow = () => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: {
      followRefId: route.query.cosId
    }
  })
}
// 新增商机
const handleAddBuss = () => {
  router.push({
    path: '/fbu/business/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}
//  编辑
const handleEdit = () => {
  let path = ''
  if (props.type === 'clients') {
    path = '/fbu/clients/edit'
  } else if (props.type === 'potential') {
    path = '/fbu/potential/edit'
  } else if (props.type === 'contract') {
    path = '/fbu/contract/edit'
  }
  if (path) {
    router.push({
      path,
      query: {
        cosId: route.query.cosId
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_footer_button, {
      loading: __props.loading,
      hideOk: ""
    }, {
      default: _withCtx(() => [
        (__props.isPublicClue)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              onClick: handleAssignPerson
            }, {
              default: _withCtx(() => [
                _createTextVNode("分配客户")
              ]),
              _: 1
            })), [
              [_directive_permission, 'fbu_public_customer_assign_btn']
            ])
          : _createCommentVNode("", true),
        (!__props.isPublicClue)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              onClick: handleTransfer
            }, {
              default: _withCtx(() => [
                _createTextVNode("转移客户")
              ]),
              _: 1
            })), [
              [_directive_permission, __props.permissionPage?.transfer]
            ])
          : _createCommentVNode("", true),
        (!__props.isPublicClue)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              onClick: handleAddConcat
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增联系人")
              ]),
              _: 1
            })), [
              [_directive_permission, __props.permissionPage?.concat_add]
            ])
          : _createCommentVNode("", true),
        (!__props.isPublicClue)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 3,
              onClick: handleAddFollow
            }, {
              default: _withCtx(() => [
                _createTextVNode("写跟进")
              ]),
              _: 1
            })), [
              [_directive_permission, __props.permissionPage?.follow_add]
            ])
          : _createCommentVNode("", true),
        (!__props.isPublicClue)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 4,
              onClick: hanleVisitor
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增访客计划")
              ]),
              _: 1
            })), [
              [_directive_permission, __props.permissionPage?.visitor_add]
            ])
          : _createCommentVNode("", true),
        (!__props.isPublicClue)
          ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
              key: 5,
              controlType: "none",
              workCode: __props.workCode,
              onClick: handleAddBuss
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增商机")
              ]),
              _: 1
            }, 8, ["workCode"])), [
              [_directive_permission, __props.permissionPage?.buss_add]
            ])
          : _createCommentVNode("", true),
        (!__props.isPublicClue)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 6,
              type: "primary",
              onClick: handleEdit
            }, {
              default: _withCtx(() => [
                _createTextVNode("编辑")
              ]),
              _: 1
            })), [
              [_directive_permission, __props.permissionPage?.edit]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(TransferModel, {
      ref_key: "transferModelRef",
      ref: transferModelRef,
      onSuccess: _cache[0] || (_cache[0] = ($event: any) => (successPage('base')))
    }, null, 512),
    _createVNode(ConcatModal, {
      ref_key: "concatModalRef",
      ref: concatModalRef,
      onSuccess: _cache[1] || (_cache[1] = ($event: any) => (successPage('contact'))),
      contactRefId: _unref(route).query.cosId
    }, null, 8, ["contactRefId"]),
    _createVNode(CustomerAssign, {
      ref_key: "customerAssignRef",
      ref: customerAssignRef,
      onFetch: _cache[2] || (_cache[2] = ($event: any) => (successPage('base')))
    }, null, 512)
  ], 64))
}
}

})